import styled, { css } from "styled-components";
import { DatePicker } from "antd";
import { theme } from "../../styles/theme";

export const INPUT_PLACEHOLDERS = css`
  // Chrome, Firefox, Opera, Safari 10.1+
  ::placeholder {
    font-weight: ${theme.fonts.weight.regular};
    color: ${theme.colors.gray200} !important;
    opacity: 1; // Firefox
  }

  // Internet Explorer 10-11
  :-ms-input-placeholder {
    font-weight: ${theme.fonts.weight.regular};
    color: ${theme.colors.gray200};
  }

  // Microsoft Edge
  ::-ms-input-placeholder {
    font-weight: ${theme.fonts.weight.regular};
    color: ${theme.colors.gray200};
  }
  font-size: ${theme.fonts.size.default};
`;

export const INPUT_FOCUS = css`
  outline: 0;
  box-shadow: initial;
`;

export const CustomDatePicker = styled(DatePicker)`
  &&& {
    &.ant-picker {
      height: ${({ height }) => height || "45px"};
      padding: 0 16px;
      background: ${({ background }) => background || theme.colors.white};
      font-family: ${theme.fonts.family};
      border: 1px solid ${({ border }) => border || theme.colors.gray200};
      border-radius: ${({ radius }) => radius || "23px"};
      color: ${theme.colors.gray200};

      &:focus-within {
        ${INPUT_FOCUS};
      }

      &-focused {
        box-shadow: none;
      }

      input {
        font-family: ${theme.fonts.family};
        width: ${({ width }) => width || null};
        height: 100%;
        background: ${({ background }) => background || theme.colors.white};
        opacity: 1;
        font-size: ${theme.fonts.size.default};
        color: ${theme.colors.gray200};

        &::placeholder {
          color: ${({ placeholderColor }) =>
            placeholderColor || theme.colors.gray200};
        }
      }
    }

    .ant-picker {
      &-suffix {
        font-size: 16px;
        margin-right: 5px;
        color: ${theme.colors.gray200};
      }

      &-active-bar {
        display: none;
      }
    }
  }
`;
